export default function errorHandler(widget, { error }) {
	const { reportUrl, environment } = widget.props.environment;
	const { http } = widget;

	if (typeof error?.location === 'string') {
		widget.error.location = error?.location;
	}

	const data = {
		$type: 'error',
		name: widget?.name,
		version: widget?.version,
		message: error?.message || '',
		stack: error?.stack,
		statusCode: error?.status,
		location: window?.location?.href,
		params: {
			status: error?.status,
			props: widget?.props,
			state: widget?.state,
			assets: widget?.assets,
			containerSelector: widget?.containerSelector
		}
	};

	if (widget?.error && !widget.error?.isLogged) {
		if (environment !== 'production') {
			console.error(data?.stack);
		}

		console.error(data);
		widget.error.isLogged = true;
	}

	if (!widget?.isRegression && !widget?.error?.sent) {
		http
			.request({
				url: reportUrl,
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: data
			})
			.then(({ response }) => {
				widget.error.sent = response?.ok;
			})
			.catch(exception => {
				console.warn('Error report not sent');
				console.warn(exception);
			});
	}
}
